/**
 * `1–50 de 1.482` — a parte contável do rodapé da paginação, sem o substantivo.
 * Cada tela completa com o que está listando ("linhas", "execuções"), porque é a
 * única parte que muda entre elas.
 */
export function pageRange(page: number, pageSize: number, total: number): string {
  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total);

  return `${start}–${end} de ${total.toLocaleString('pt-BR')}`;
}
